import chartbitSlice from './slice';

const chartbitReducer = chartbitSlice.reducer;

export default chartbitReducer;
